<template>
  <div class="left-menu flex">
    <a-menu
      :default-selected-keys="activeMenu"
      :default-open-keys="defaultOpenMenuList"
      mode="inline"
      :inline-collapsed="collapsed"
      @click="handleClick"
    >
      <template v-for="menuItem in menuList">
        <a-sub-menu
          v-if="
            menuItem.subMenu && menuItem.subMenu.length
              ? menuItem.id
                ? userInfo.MenuList.includes(menuItem.id)
                : true
              : false
          "
          :key="menuItem.key"
        >
          <template #title>
            <!-- <i class="iconfont iconGroup5Copy4 pr25" :title="menuItem.title"></i> -->
            <img
              class="menu-icon"
              :src="menuItem.icon"
              :title="menuItem.title"
            />
            <span>{{ menuItem.title }}</span>
          </template>
          <template v-for="subMenuItem in menuItem.subMenu">
            <a-menu-item
              v-if="
                subMenuItem.id
                  ? userInfo.MenuList.includes(subMenuItem.id)
                  : true
              "
              :key="subMenuItem.key"
            >
              <img
                v-if="subMenuItem.icon"
                class="menu-sub-icon"
                :src="subMenuItem.icon"
                :title="subMenuItem.title"
              />
              <span class="child-menu-title">{{ subMenuItem.title }}</span>
            </a-menu-item>
          </template>
        </a-sub-menu>
        <a-menu-item
          v-else-if="
            menuItem.id ? userInfo.MenuList.includes(menuItem.id) : true
          "
          :key="menuItem.key"
        >
          <img class="menu-icon" :src="menuItem.icon" :title="menuItem.title" />
          <span>{{ menuItem.title }}</span>
        </a-menu-item>
      </template>
      <!-- <a-sub-menu key="orderSearch">
        <span slot="title">
          <i class="iconfont iconGroup5Copy4 pr25"></i>
          <span>订单查询</span></span>

        <a-menu-item key="国际海运" >
          <a-popover placement="left">
            <template slot="content">
              <p>业务范围： 海运进出口、罐厢外贸、拼箱</p>
            </template>
            <span class="pl20">国际海运</span>
          </a-popover>
        </a-menu-item>
        <a-menu-item key="国际空运">
          <a-popover placement="left">
            <template slot="content">
              <p>业务范围：空运进出口</p>
            </template>
            <span class="pl20">国际空运</span>
          </a-popover>
        </a-menu-item>
        <a-menu-item key="国际铁路">
          <a-popover placement="left">
            <template slot="content">
              <p>业务范围：铁路外贸</p>
            </template>
            <span class="pl20">国际铁路</span>
          </a-popover>
        </a-menu-item>
        <a-menu-item key="国内运输">
          <a-popover placement="left">
            <template slot="content">
              <p>业务范围：集运、配送、罐箱公路、罐箱水路、内贸水运、内贸铁路</p>
            </template>
            <span class="pl20">国内运输</span>
          </a-popover>
        </a-menu-item>
        <a-menu-item key="国内仓储">
          <span class="pl20">国内仓储</span>
        </a-menu-item>
      </a-sub-menu>
      -->
      <!-- <a-menu-item key="invoiceSearch">
        <i class="iconfont iconGroup5Copy4_1 pr25 ft14"></i>
        <span>发票查询</span>
      </a-menu-item> -->
      <!--
      <a-menu-item key="contractSearch">
        <i class="iconfont iconGroup5Copy4_2 pr25"></i>
        <span>合同查询</span>
      </a-menu-item>
      <a-menu-item key="integralSearch">
        <i class="iconfont iconGroup5Copy4_3 pr25"></i>
        <span>积分查询</span>
      </a-menu-item>
      <a-menu-item key="evaluateSearch">
        <i class="iconfont iconGroup5Copy4_4 pr25"></i>
        <span>评价查询</span>
      </a-menu-item> -->
      <!-- <a-menu-item key="dataBoard">
        <i class="iconfont iconGroup5Copy4_2 pr25"></i>
        <span>数据看板</span>
      </a-menu-item>
      <a-menu-item key="tmsOrder">
        <i class="iconfont iconGroup5Copy4_3 pr25"></i>
        <span>订单查询</span>
      </a-menu-item>
      <a-menu-item key="tmsBill">
        <i class="iconfont iconGroup5Copy4_4 pr25"></i>
        <span>账单查询</span>
      </a-menu-item>
      -->
    </a-menu>
  </div>
</template>
<script>
import i18n from '@/i18n/i18n'
import { USER_INFO, ACCESS_TOKEN } from '@/store/mutation-types';
export default {
  props: {
    collapsed: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      activeMenu: [],
      menuList: [
        {
          title: i18n.t('menu.UserInterface'),
          key: '/dashboard',
          id: 'Dashboard',
          icon: require('@/assets/images/common/menu-icon/dashboard.png')
        },
        {
          title: i18n.t('menu.OrderInquiry'),
          key: 'order-manage',
          icon: require('@/assets/images/common/menu-icon/order.png'),
          id: 'Tracking',
          subMenu: [
            // {
            //   title: 'TMS',
            //   key: '/dataBoard'
            // },
            // {
            //   title: '订单查询',
            //   key: '/tmsOrder'
            // },
            // {
            //   title: '账单查询',
            //   key: '/tmsBill'
            // }
            {
              title: i18n.t('menu.SeaFreight'), // 国际海运
              key: '/seaTransportation/sea-transport-list',
              id: 'OceanFreight',
              icon: require('@/assets/images/common/menu-icon/sea.png'),
            },
            {
              title: i18n.t('menu.AirFreight'), // 国际空运
              key: '/airTransport/air-transport-list',
              id: 'AirFreight',
              icon: require('@/assets/images/common/menu-icon/air.png'),
            },
            {
              title: i18n.t('menu.InternationalRailwayFreight'), // 铁路
              key: '/railway/ri-dashboard',
              id: 'RailwayFreight',
              icon: require('@/assets/images/common/menu-icon/highway.png'),
            },
            {
              title: i18n.t('menu.DomesticTransportation'), // 国内运输
              key: '/dataBoard',
              id: 'Trucking',
              icon: require('@/assets/images/common/menu-icon/truck.png'),
            },
            // {
            //   title: i18n.t('menu.DomesticMarineTransportation'), // 国内水运
            //   key: '/mmTransportation/mm-transport-list'
            // },
            // {
            //   title: '国内仓储',
            //   key: '/storageSearch/国内仓储'
            // },
            {
              title: i18n.t('menu.DomesticWarehousing'), // 仓储
              key: '/wms/wms-list',
              id: 'Warehousing',
              icon: require('@/assets/images/common/menu-icon/warehouse.png'),
            },
            {
              title: i18n.t('menu.TankService'), // 罐箱
              key: '/tankNoSearch/tankNo-list',
              id: 'TankService',
              icon: require('@/assets/images/common/menu-icon/block.png'),
            }
          ]
        },
        // {
        //   title: '海运订单中心',
        //   key: '/seaTransportation/sea-transport-list',
        //   icon: require('@/assets/images/common/menu-icon/invoice.png')
        // },
        // {
        //   title: '空运订单中心',
        //   key: '/airTransport/air-transport-list',
        //   icon: require('@/assets/images/common/menu-icon/invoice.png')
        // },
        {
          title: i18n.t('menu.InvoiceInquiry'), // 发票查询
          key: '/invoiceSearch/invoice-list',
          id: 'Invoice',
          icon: require('@/assets/images/common/menu-icon/invoice.png')
        },
        {
          title: i18n.t('menu.ContractInquiry'),  // 合同查询
          key: '/contractSearch',
          id: 'Agreement',
          icon: require('@/assets/images/common/menu-icon/contract.png')
        },
        {
          title: i18n.t('menu.PointsMall'),  // 积分商城
          key: '/pointsMall',
          icon: require('@/assets/images/common/menu-icon/mall.png')
        },
        // {
        //   title: i18n.t('menu.HistoricalRedemptionRecords'),
        //   key: '/exchangeRecord',
        //   icon: require('@/assets/images/common/menu-icon/history.png')
        // },
        {
          title: i18n.t('menu.EvaluationFeedback'),
          key: '/service-feed',
          icon: require('@/assets/images/common/menu-icon/feedback.png'),
          subMenu: [
            {
              title: i18n.t('menu.ServiceEvaluation'),
              key: '/serviceRating',
              icon: require('@/assets/images/common/menu-icon/evalue.png'),
            },
            {
              title: i18n.t('menu.Feedback'),
              key: '/feedback',
              icon: require('@/assets/images/common/menu-icon/remark.png'),
            }
          ]
        },
        {
          title: i18n.t('menu.UserCenter'),
          key: 'user-center',
          icon: require('@/assets/images/common/menu-icon/usercenter.png'),
          subMenu: [
            // {
            //   title: i18n.t('menu.CompanyInformation'),
            //   key: '/company-info',
            //   icon: require('@/assets/images/common/menu-icon/company.png'),
            // },
            {
              title: i18n.t('menu.ChangePassword'),
              key: '/reset-password',
              icon: require('@/assets/images/common/menu-icon/changePwd.png'),
            }
          ]
        }
      ],
      oldMenuList: [
        {
          title: i18n.t('menu.OrderInquiry'),
          icon: 'iconGroup5Copy4',
          children: [
            {
              title: i18n.t('menu.SeaFreight')
            },
            {
              title: i18n.t('menu.AirFreight')
            },
            {
              title: i18n.t('menu.InternationalRailwayFreight')
            },
            {
              title: i18n.t('menu.DomesticTransportation')
            },
            {
              title: i18n.t('menu.DomesticWarehousing')
            },
            {
              title: i18n.t('menu.TankService')
            }
          ]
        },
        {
          title: i18n.t('menu.InvoiceInquiry'),
          icon: 'iconGroup5Copy4_1'
        },
        {
          title: i18n.t('menu.ContractInquiry'),
          icon: 'iconGroup5Copy4_2'
        },
        {
          title: i18n.t('menu.PointsMall'),
          icon: 'iconGroup5Copy4_3'
        },
        {
          title: i18n.t('menu.EvaluationFeedback'),
          icon: 'iconGroup5Copy4_4'
        }
      ],
    }
  },
  computed: {
    defaultOpenMenuList() {
      return this.menuList.reduce((acc, item) => {
        // if (item.subMenu && item.subMenu.length) {
        //   acc.push(item.key)
        // }
        return acc
      }, [])
    }
  },
  computed: {
    userInfo() {
      return this.$ls.get(USER_INFO) || {}
    }
  },
  methods: {
    handleClick({ item, key, keyPath }) {
      if (keyPath && keyPath[0].indexOf('/') === 0) {
        this.$router.push({
          path: keyPath[0],
        })
        this.$emit('menuClick')
      }
      // if (e.keyPath.length >= 2) {
      //   if (e.keyPath[0] === '国内仓储') {
      //     this.$router.push({
      //       name: 'storageSearch',
      //       params: {
      //         type: e.key
      //       }
      //     })
      //   } else {
      //     this.$router.push({
      //       name: e.keyPath[1],
      //       params: {
      //         type: e.key
      //       }
      //     })
      //   }
      // } else if (e.keyPath.length === 1) {
      //   if (e.key.length === 1) return
      //   this.$router.push({
      //     name: e.key
      //   })
      // }
    },
  },
  created() {
    // if (this.$route.name === 'orderSearch' || this.$route.name === 'storageSearch') {
    //   this.activeMenu = [this.$route.params.type]
    // } else {
    //   this.activeMenu = [this.$route.name]
    // }
  }
}
</script>
<style lang="less">
@import '../../styles/var.less';
// ::-webkit-scrollbar {
//   display: none;
// }
.ant-menu-submenu-inline
  > .ant-menu-submenu-title
  .ant-menu-submenu-arrow::before,
.ant-menu-submenu-open.ant-menu-submenu-inline
  > .ant-menu-submenu-title
  .ant-menu-submenu-arrow::before {
  background: white !important;
}
.ant-menu-submenu-inline
  > .ant-menu-submenu-title
  .ant-menu-submenu-arrow::after,
.ant-menu-submenu-open.ant-menu-submenu-inline
  > .ant-menu-submenu-title
  .ant-menu-submenu-arrow::after {
  background: white !important;
}
.ant-menu-item:hover,
.ant-menu-item-active,
.ant-menu:not(.ant-menu-inline) .ant-menu-submenu-open,
.ant-menu-submenu-active,
.ant-menu-submenu-title:hover {
  color: #62c8e5 !important;
}
.ant-menu-inline,
.ant-menu-vertical,
.ant-menu-vertical-left {
  border-right-color: transparent !important;
}
.ant-menu-item-selected {
  color: #51abc3 !important;
}
.ant-drawer .ant-drawer-content {
  background-color: #54abc3;
}
.left-menu {
  ul {
    background-color: #54abc3;
  }
  li {
    background-color: #54abc3;
    color: white;
  }
  .ant-menu-submenu > .ant-menu {
    background-color: #54abc3;
  }
  .ant-menu-inline-collapsed > .ant-menu-item {
    padding-left: 24px !important;
  }
  .ant-menu-inline-collapsed .ant-menu-submenu > .ant-menu-submenu-title {
    padding-left: 24px !important;
  }
  .ant-menu-item,
  .ant-menu-submenu-title {
    display: flex;
    align-items: center;
  }
  .child-menu-title {
    padding-left: 22px;
  }
}
.ant-menu-submenu-open.ant-menu-submenu-selected {
  .ant-menu-inline {
    background-color: white;
    .ant-menu-item {
      margin-top: 0;
      margin-bottom: 0;
    }
  }

  .ant-menu-item.ant-menu-item-selected {
    background: rgba(70, 154, 189, 0.1);
  }
}
.ant-menu-sub.ant-menu-inline > .ant-menu-item {
  height: 50px;
  line-height: 50px;
}
.ant-popover-placement-right.ant-popover {
  z-index: 9991 !important;
}
</style>
<style lang="less" scoped>
@import '../../styles/var.less';
.iconfont {
  display: inline-block;
  width: 45px;
}
.ant-menu-inline-collapsed {
  width: 70px;
}

.menu-icon {
  width: 22px;
  height: 22px;
  margin-right: 24px;
}
.menu-sub-icon {
  width: 18px;
  height: 18px;
  margin-right: 0;
}

// .menu-item{
//     height: 70px;
//     line-height: 70px;
//     padding: 0 15px;
//     font-size: 16px;
//     a{
//       display: block;
//       color: #fff;
//     }
//     &.active{
//       position: relative;
//       background-color: @dark-main-color;
//       &::before{
//         position: absolute;
//         content: "";
//         width: 100%;
//         height: 4px;
//         top: 0;
//         left: 0;
//         background-color: #D1F9FF;
//       }
//     }
//   }
</style>
